import { toast } from "sonner";

/**
 * Show an error toast with optional retry action
 * Error toasts persist until dismissed or action taken
 */
export function showError(
  message: string,
  options?: {
    retry?: () => void;
    description?: string;
  },
) {
  toast.error(message, {
    duration: options?.retry ? Infinity : 8000,
    description: options?.description,
    action: options?.retry
      ? {
          label: "Retry",
          onClick: options.retry,
        }
      : undefined,
  });
}

/**
 * Show a success toast (auto-dismisses after 4s)
 */
export function showSuccess(message: string) {
  toast.success(message, {
    duration: 4000,
  });
}
